export class LoginCredentials {
    username: string | undefined;
    password: string | undefined;
    companyId: number | undefined;
    companySiteId: number | undefined;
    refresh : string | undefined;
    otp : string | undefined;
    resetPin : boolean = false;
    saveDevice : boolean = false;
    constructor() {}
}
